import React from 'react'
import { motion } from 'framer-motion'
import { Compass, Target } from 'lucide-react'
import { Section, Card } from './ui'
import { VISION, MISSION } from '../constants'
import { cn } from '../utils'

const VisionMissionSection: React.FC = () => {
  const items = [
    {
      key: 'vision',
      label: 'Vision',
      icon: Compass,
      accent: 'secondary' as const,
      text: VISION,
    },
    {
      key: 'mission',
      label: 'Mission',
      icon: Target,
      accent: 'primary' as const,
      text: MISSION,
    },
  ]

  return (
    <Section background="muted" padding="lg">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {items.map((item, i) => {
          const Icon = item.icon
          const isBlue = item.accent === 'secondary'
          return (
            <motion.div
              key={item.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <Card variant="default" padding="lg" className="h-full relative overflow-hidden">
                <div
                  className={cn(
                    'absolute -top-16 -right-16 w-40 h-40 rounded-full blur-3xl pointer-events-none',
                    isBlue
                      ? 'bg-secondary-100/60 dark:bg-secondary-900/30'
                      : 'bg-primary-100/60 dark:bg-primary-900/30'
                  )}
                />
                <div className="relative">
                  <div
                    className={cn(
                      'w-11 h-11 rounded-lg flex items-center justify-center mb-5',
                      isBlue
                        ? 'bg-secondary-50 dark:bg-secondary-900/40 text-secondary-500 dark:text-secondary-300'
                        : 'bg-primary-50 dark:bg-primary-900/40 text-primary-600 dark:text-primary-300'
                    )}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <p
                    className={cn(
                      'text-xs font-medium tracking-[0.22em] uppercase mb-3',
                      isBlue
                        ? 'text-secondary-500 dark:text-secondary-300'
                        : 'text-primary-600 dark:text-primary-300'
                    )}
                  >
                    Our {item.label}
                  </p>
                  <p className="text-lg text-gray-700 dark:text-gray-200 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </Card>
            </motion.div>
          )
        })}
      </div>
    </Section>
  )
}

export default VisionMissionSection
